<button
  #originRef
  (click)="showPopover()"
  matTooltip="{{ 'HISTORY' | translate }}"
  [class.active]="dropdownOpen"
  class="button"
  mat-icon-button
  type="button"
  aria-label="history">
  <mat-icon [icIcon]="icHistory"></mat-icon>
</button>
